import QRCode from "qrcode";
import {useEffect, useState} from "react";

export const useFeeQrCode = (feeLink: string | null) => {
    const [qrCode, setQrCode] = useState<string | null>(null);
    const [failed, setFailed] = useState<boolean>(false);

    useEffect(() => {
        setQrCode(null);
        setFailed(false);

        if (!feeLink) {
            return;
        }

        let superseded = false;

        QRCode.toDataURL(feeLink)
            .then(code => {
                if (!superseded) {
                    setQrCode(code);
                }
            })
            .catch(e => {
                console.error("qr code error", e);
                if (!superseded) {
                    setFailed(true);
                }
            });

        return () => {
            superseded = true;
        };
    }, [feeLink]);

    return {qrCode, failed};
};
